import { SocketEvent } from "../SocketEvent";
import { SocketEventInterface } from "../SocketEventInterface";
import { SocketEventProcessorInterface } from "../SocketEventProcessorInterface";
import Constants from "../../Action/Constants";
import AgencyFeeFactory from "../../Entity/Factories/AgencyFeeFactory";
import { AgencyFeeInterface } from "../../Entity/Entities/AgencyFee/AgencyFeeInterface";

class AgencyFeeCreate extends SocketEvent implements SocketEventInterface {

  protected props: any;

  constructor() {
    super();
  }

  public process(props: SocketEventProcessorInterface): void {
    const agencyFee: AgencyFeeInterface = AgencyFeeFactory.create(props.res);

    this.props.dispatch({
      type: Constants.GLOBAL_AGENCY_FEE_CREATE_SUCCESS,
      payload: {
        agencyFee: agencyFee
      }
    });
  }

}

export { AgencyFeeCreate };
